<div *ngIf="weatherAvailable && forecastAvailable" class="container layout">
    <ng-container *ngFor="let weatherForecast of weatherForecasts; index as index">
        <div class="city">
            <weather-card class="card mat-elevation-z8" [weather]="weatherForecast.weather"
                [forecast]="weatherForecast.forecast" [city]="cities[index]"></weather-card>
            <forecast class="forecast  mat-elevation-z8" [forecast]="weatherForecast.forecast" [index]="index">
            </forecast>
        </div>
    </ng-container>
</div>